import { format, isValid, parseISO } from 'date-fns';
import { de } from 'date-fns/locale'; // @FIXME needs to be dynamic (probably via context)
export const useTravelPeriodLabel = ({
  startDate,
  endDate,
  short = false,
  withWeekDay = false,
  showEndDateYear = true
}) => {
  const startDateParsed = parseISO(startDate || '');
  const endDateParsed = parseISO(endDate || '');
  if (!isValid(startDateParsed)) {
    return '';
  }
  if (!isValid(endDateParsed)) {
    return format(startDateParsed, `P`, {
      locale: de
    });
  }
  const datePattern = short ? 'dd.MM.yy' // @FIXME i18n
  : 'P';
  const startDatePattern = startDateParsed.getFullYear() === endDateParsed.getFullYear() ? 'dd.MM.' : datePattern;
  const endDatePattern = !showEndDateYear && startDateParsed.getFullYear() === endDateParsed.getFullYear() ? 'dd.MM.' : datePattern;
  const startDateFormatted = format(startDateParsed, withWeekDay ? `EEEEEE., ${startDatePattern}` : startDatePattern, {
    locale: de
  });
  const endDateFormatted = format(endDateParsed, withWeekDay ? `EEEEEE., ${endDatePattern}` : endDatePattern, {
    locale: de
  });
  return `${startDateFormatted} - ${endDateFormatted}`;
};